var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:['list', _vm.disabled && 'is-disabled'],attrs:{"disabled":_vm.disabled,"data-testid":"list"}},_vm._l((_vm.listItems),function(item,index){return _c('li',{key:index,staticClass:"list__item"},[_vm._t("default",null,{"item":item})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }